import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	selectedPlan: null,
	billingType: 'monthly',
	subscriptionCompleted: false,
};

const subscriptionSlice = createSlice({
	name: 'subscription',

	initialState,

	reducers: {
		setPlan: (state, action) => {
			state.selectedPlan = action.payload;
		},

		setBillingType: (state, action) => {
			state.billingType = action.payload;
		},

		setSubscriptionCompleted: (state, action) => {
			state.subscriptionCompleted = action.payload;
		},

		clearSubscription: (state) => {
			state.selectedPlan = null;
			state.billingType = 'monthly';
			state.subscriptionCompleted = false;
		},
	},
});

export const { setPlan, setBillingType, clearSubscription, setSubscriptionCompleted } =
	subscriptionSlice.actions;

export default subscriptionSlice.reducer;
